'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.AddToCalendar = AddToCalendar;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('./buttons');

var _icons = require('./icons');

var _popups = require('./popups');

var _lists = require('./lists');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function AddToCalendar(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      calendars = _ref.calendars,
      _ref$cb = _ref.cb,
      cb = _ref$cb === undefined ? function () {} : _ref$cb;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showCalenderOptions = _useState2[0],
      setShowCalenderOption = _useState2[1];

  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_buttons.PrimaryBtn, {
    onClick: function onClick() {
      setShowCalenderOption(!showCalenderOptions);
    },
    disabled: disabled
  }, 'Add To Calendar', _react2.default.createElement(_icons.CalenderIcon, {
    style: {
      marginLeft: '.5em'
    }
  })), _react2.default.createElement(_popups.Modal, {
    isVisible: showCalenderOptions,
    shade: true,
    close: function close() {
      return setShowCalenderOption(!showCalenderOptions);
    }
  }, _react2.default.createElement('h3', null, 'Add To Calendar'), _react2.default.createElement('ul', null, calendars && Object.entries(calendars).map(function (calendar) {
    return _react2.default.createElement('a', {
      href: calendar[1],
      onClick: function onClick() {
        return cb();
      },
      key: calendar[0]
    }, _react2.default.createElement(_lists.ListItem, null, _react2.default.createElement('h4', {
      style: {
        textTransform: 'capitalize'
      }
    }, calendar[0] === 'ics' ? 'Apple Calendar' : calendar[0]), _react2.default.createElement(_icons.RightChevron, null)));
  }))));
}